export type SearchCategory =
    | 'wallet'
    | 'ticker'
    | 'cohort'
    | 'unknown'
    | 'swear'
    | 'builder'
    | 'refCode'
    | 'username'
    | 'twitter'
    | 'hlName'
    | 'hyperliquidName';
export const storageKey = `@coin_${import.meta.env.REACT_APP_ENVR}_hypersearch`;
